<div class="row welcome">
  <div class="col"></div>
  <div class="col-md-12 col-lg-10 col-xl-8">

    <div class="row  ">
      <div class="welcome col d-flex pt-2 pb-2 mb-2">
        <div class="pt-2"><img height="50" src="assets/img/logo-SEW.png"></div>
        <div class="ml-auto pt-5"><img height="25" src="assets/img/logo-HWFL.png"></div>
      </div>
    </div>

  </div>
  <div class="col"></div>
</div>

<div class="row  ">
  <div class="col wave" >
  
  </div>
</div>